/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChartAreaInteractive } from "@/components/chart-area-interactive";
// import { DataTable } from "@/components/data-table";
import { SectionCards } from "@/components/section-cards";

// import data from "../data/data.json";
import { useEffect, useState } from "react";
import bgImage from "@/assets/favicon.png"
import apiService from "@/services/apiService";
import { getUserInfo } from "@/services/userService";

export default function Dashboard() {
  const [dashboardData, setDashboardData] = useState(null)
  useEffect(() => {
    fetchDashboard()
  }, [])
  const fetchDashboard = async () => {
    const userInfo:any = getUserInfo();
    let user_id = null;
    if(userInfo){
      user_id = userInfo.id;
    }
    const data:any = await apiService.get(`v1/dashboard?user_id=${user_id}`)
    setDashboardData(data)
  }
  return (
    <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
      <div
        className="absolute inset-0 bg-no-repeat bg-center bg-contain opacity-3 pointer-events-none"
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      />
      {dashboardData && <SectionCards data={dashboardData} />}
      <div className="px-4 lg:px-6">
        <ChartAreaInteractive />
      </div>
      {/* <DataTable data={data} /> */}
    </div>
  );
}
